import { z } from "zod";

export const zRequiredString = (message = "Required") =>
  z
    .string()
    .min(1, { message })
    .refine((data) => data.trim() !== "", { message });

export const zRequiredNumber = (message = "Required") =>
  z.number().refine((data) => data !== undefined, { message });
